import { render, staticRenderFns } from "./PageOne.vue?vue&type=template&id=74cad798&scoped=true&"
import script from "./PageOne.vue?vue&type=script&lang=js&"
export * from "./PageOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cad798",
  null
  
)

export default component.exports